<template>
	<a class="text-button"><slot></slot></a>
</template>
<script>
	export default {
		name: 'textButton',
		props: {
			text: {
				type: String,
				default: 'btn'
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/textButton/textButton.vue